import styled from '@emotion/styled'
import { metrics, colors, zIndex, fonts } from 'component-library/__styling/settings'
import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { WebLink } from 'common/navigation/web-link'

const navScrollShadowSize = 30

export const StyledQuickLinks = styled('div')<{ hasBackgroundFill: boolean }>(
    ({ hasBackgroundFill }) => ({
        backgroundColor: hasBackgroundFill ? colors.white : undefined,
    }),
    {
        padding: `0 0 0 ${calcRem(metrics.thewest.margins.outerMargin)}`,
        margin: '0 auto',

        [breakpoint('sm')]: {
            maxWidth: metrics.thewest.mainContentWidth,
            padding: `0 ${calcRem(metrics.thewest.margins.outerMargin)}`,
        },
    }
)

export const StyledNav = styled('nav')({
    fontFamily: fonts.thewest.sansSerif,
    color: colors.thewest.greyGorilla,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    position: 'relative',
})

export const StyledHeading = styled('h2')({
    fontSize: calcRem(16),
    fontWeight: 600,
    margin: 0,
    flexShrink: 0,
})

export const StyledNavList = styled('ul')({
    listStyle: 'none',
    margin: `0 0 0 ${calcRem(metrics.thewest.margins.sm)}`,
    padding: 0,
    display: 'flex',
    flexWrap: 'nowrap',
    alignContent: 'center',
    textTransform: 'uppercase',
    fontWeight: 500,
    position: 'relative',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch',
    MsOverflowStyle: 'none',

    '&::-webkit-scrollbar': {
        display: 'none',
    },

    backgroundImage: `
        radial-gradient(
            ellipse ${navScrollShadowSize}px 210% at ${navScrollShadowSize * -0.25}px center,
                ${colors.thewest.greyKoala} 0%,
                transparent 50%)
    `,

    // Mask the gradient until needed
    '&::before': {
        content: `''`,
        minWidth: 10,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        zIndex: zIndex.thewest.mainNavScrollShadow,
        backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0), ${colors.white} 40%)`,
    },
})

export const StyledNavItem = styled('li')({
    padding: calcRem(metrics.thewest.margins.sm),
})

export const StyledLink = styled(WebLink)(({ theme }) => ({
    textDecoration: 'none',
    transition: 'background 250ms ease-out',
    color: 'currentColor',

    '&:hover': {
        color: theme.sectionValues.primaryColor,
    },

    '&:focus': {
        textDecoration: 'underline',
        outline: 'none',
    },
}))
